export const BASE_URL = 'https://beta.thewavesocial.com';
